import React from 'react'
import {
    Tooltip,
    Colors,
    Icon,
    Intent,
    Button,
    Popover,
    Position,
} from "@blueprintjs/core";
import Moment from "moment";
import { protoString } from "../../helper";


const TableLine = ({ metadata, onContextMenu, buildContextMenu, data, session }) => {
    return (
        <tr className='block-session' onContextMenu={onContextMenu} >
            <td className='d-none-comp'>Session status</td>
            <td className='d-none-mob'>
                {metadata.status === "OPEN" ? (
                    <Tooltip content="Opened session" position={Position.TOP}>
                        <Icon style={{ color: Colors.GREEN4 }} icon="full-circle" />
                    </Tooltip>
                ) : (
                        <Tooltip content="Closed session" position={Position.TOP}>
                            <Icon style={{ color: Colors.GRAY1 }} icon="full-circle" />
                        </Tooltip>
                    )}
            </td>
            <td className='d-none-comp'>
                {metadata.status === 'OPEN' ?
                    'Open'
                    :
                    'Closed'
                }
            </td>
            <td className='d-none-comp'>Session name</td>
            <td>
                {metadata.name || (
                    <span
                        className="bp3-text-muted bp3-text-disabled"
                        style={{ color: Colors.RED3 }}
                    >
                        Not specified
                    </span>
                )}
            </td>
            <td className='d-none-comp'>Shortname</td>
            <td>
                {metadata.shortname || (
                    <span
                        className="bp3-text-muted bp3-text-disabled"
                        style={{ color: Colors.RED3 }}
                    >
                        Not specified
                    </span>
                )}
            </td>
            <td className='d-none-comp'>Number of sequences</td>
            <td>
                {data && data.sequences ? (
                    data.sequences.length
                ) : (
                        <span
                            className="bp3-text-muted"
                            style={{ color: Colors.RED3 }}
                        >
                            Sequences are not generated
                        </span>
                    )}
            </td>
            <td className='d-none-comp'>Created at</td>
            <td>
                {Moment(metadata.createdDate).format("DD/MM/YYYY - HH:mm")}
            </td>
            <td className='d-none-comp'>Type</td>
            <td>
                {metadata.type || (
                    <span
                        className="bp3-text-muted bp3-text-disabled"
                        style={{ color: Colors.RED3 }}
                    >
                        Not specified
                    </span>
                )}
            </td>
            <td className='d-none-comp'>Protocol</td>
            <td>
                {metadata.protocol ?
                    protoString(metadata.protocol)
                    :
                    <span
                        className="bp3-text-muted bp3-text-disabled"
                        style={{ color: Colors.RED3 }}
                    >
                        Not specified
                    </span>
                }
            </td>
            <td className='d-none-comp'>Options</td>
            <td style={{ textAlign: "right" }}>
                <Popover
                    content={buildContextMenu()}
                    position={Position.BOTTOM}
                >
                    <Button icon="more" intent={Intent.NONE} />
                </Popover>
            </td>
        </tr>

    )
}

export default TableLine
